import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import ShieldIcon from '@mui/icons-material/Shield';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import BuildIcon from '@mui/icons-material/Build';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import DescriptionIcon from '@mui/icons-material/Description';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PeopleIcon from '@mui/icons-material/People';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ReceiptIcon from '@mui/icons-material/Receipt';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

export const ALL_MENU_CATALOG = [
  { id: 'dashboard', icon: DashboardIcon, path: '/dashboard', label: 'Dashboard', module: 'dashboard', category: 'General' },
  { id: 'products', icon: InventoryIcon, path: '/products', label: 'Products', module: 'products', category: 'Inventory' },
  { id: 'categories', icon: CategoryIcon, path: '/products/categories', label: 'Categories', module: 'products', category: 'Inventory' },
  { id: 'warranty-periods', icon: ShieldIcon, path: '/products/warranty-periods', label: 'Warranty Periods', module: 'products', category: 'Inventory' },
  { id: 'inventory', icon: WarehouseIcon, path: '/inventory', label: 'Inventory', module: 'inventory', category: 'Inventory' },
  { id: 'imei-tracking', icon: QrCodeScannerIcon, path: '/inventory/imei-tracking', label: 'IMEI Tracking', module: 'inventory', category: 'Inventory' },
  { id: 'rma', icon: AssignmentReturnIcon, path: '/rma', label: 'RMA', module: 'inventory', category: 'Inventory' },
  { id: 'repairs', icon: BuildIcon, path: '/repairs', label: 'Repairs', module: 'sales', category: 'Sales & Services' },
  { id: 'trade-ins', icon: SwapHorizIcon, path: '/trade-ins', label: 'Trade-ins', module: 'sales', category: 'Sales & Services' },
  { id: 'sales', icon: ShoppingCartIcon, path: '/sales', label: 'Sales', module: 'sales', category: 'Sales & Services' },
  { id: 'pos', icon: PointOfSaleIcon, path: '/sales/orders/new', label: 'POS', module: 'sales', category: 'Sales & Services' },
  { id: 'quotations', icon: DescriptionIcon, path: '/quotations', label: 'Quotations', module: 'quotations', category: 'Sales & Services' },
  { id: 'van-sales', icon: DirectionsCarIcon, path: '/van-sales', label: 'Van Sales', module: 'van-sales', category: 'Sales & Services' },
  { id: 'purchases', icon: LocalShippingIcon, path: '/purchases', label: 'Purchases', module: 'purchases', category: 'Procurement' },
  { id: 'customers', icon: PeopleIcon, path: '/customers', label: 'Customers', module: 'sales', category: 'Sales & Services' },
  { id: 'expenses', icon: ReceiptLongIcon, path: '/expenses', label: 'Expenses', module: 'expenses', category: 'Finance' },
  { id: 'bank-accounts', icon: AccountBalanceIcon, path: '/finance/bank-accounts', label: 'Bank Accounts', module: 'finance', category: 'Finance' },
  { id: 'cash-bank-operations', icon: AccountBalanceWalletIcon, path: '/finance/cash-bank-operations', label: 'Cash & Bank Ops', module: 'finance', category: 'Finance' },
  { id: 'bank-reconciliation', icon: FactCheckIcon, path: '/finance/bank-reconciliation', label: 'Bank Reconciliations', module: 'finance', category: 'Finance' },
  { id: 'fixed-assets', icon: AccountBalanceWalletIcon, path: '/fixed-assets', label: 'Fixed Assets', module: 'fixed-assets', category: 'Finance' },
  { id: 'vouchers', icon: ReceiptIcon, path: '/finance/vouchers', label: 'Vouchers', module: 'finance', category: 'Finance' },
  { id: 'chequebooks', icon: MenuBookIcon, path: '/finance/chequebooks', label: 'Chequebooks', module: 'finance', category: 'Finance' },
  { id: 'cheques', icon: LocalAtmIcon, path: '/finance/cheques', label: 'Cheques', module: 'finance', category: 'Finance' },
  { id: 'users', icon: PersonIcon, path: '/users', label: 'Users', module: 'users', category: 'Administration' },
  { id: 'roles', icon: SettingsIcon, path: '/roles', label: 'Roles', module: 'roles', category: 'Administration' },
  { id: 'reports', icon: AssessmentIcon, path: '/reports', label: 'Reports', module: 'reports', category: 'Analytics' },
  { id: 'super-admin', icon: BusinessCenterIcon, path: '/super-admin', label: 'Tenancy', isSuper: true, category: 'Administration' },
];

/**
 * Merges raw tenant menu order setting with all available catalog items
 * Handles ordering, visibility, and newly added modules.
 * 
 * @param {Array|string|null} menuOrderSetting - raw saved company menuOrder
 * @returns {Array} List of all menu catalog items ordered and decorated with `visible: boolean`
 */
export function resolveMenuConfig(menuOrderSetting) {
  let parsed = [];
  if (Array.isArray(menuOrderSetting)) {
    parsed = menuOrderSetting;
  } else if (typeof menuOrderSetting === 'string' && menuOrderSetting.trim()) {
    try {
      parsed = JSON.parse(menuOrderSetting);
    } catch (e) {
      console.warn('Failed to parse menuOrder setting:', e);
      parsed = [];
    }
  }

  if (!Array.isArray(parsed) || parsed.length === 0) {
    return ALL_MENU_CATALOG.map((item) => ({ ...item, visible: true }));
  }

  // Map of path/id -> item config
  const configMap = new Map();
  parsed.forEach((entry, idx) => {
    const key = typeof entry === 'string' ? entry : (entry.id || entry.path);
    if (key) {
      configMap.set(key, {
        orderIndex: idx,
        visible: typeof entry === 'object' && entry.visible !== undefined ? !!entry.visible : true,
      });
    }
  });

  // Sort and assign visibility
  const catalogCopy = ALL_MENU_CATALOG.map((item) => {
    const cfg = configMap.get(item.id) || configMap.get(item.path);
    return {
      ...item,
      visible: cfg ? cfg.visible : true,
      _orderIndex: cfg ? cfg.orderIndex : 9999,
    };
  });

  catalogCopy.sort((a, b) => a._orderIndex - b._orderIndex);

  return catalogCopy.map(({ _orderIndex, ...rest }) => rest);
}

/**
 * Preset ordering templates that tenants can quickly choose from
 */
export const MENU_PRESETS = [
  {
    id: 'default',
    name: 'Default System Flow',
    description: 'Standard order starting with Dashboard, Products, Inventory, Sales, Finance, Admin.',
    order: [
      'dashboard', 'products', 'categories', 'warranty-periods', 'inventory',
      'imei-tracking', 'rma', 'repairs', 'trade-ins', 'sales', 'pos',
      'quotations', 'van-sales', 'purchases', 'customers', 'expenses',
      'bank-accounts', 'cash-bank-operations', 'bank-reconciliation', 'fixed-assets',
      'vouchers', 'chequebooks', 'cheques', 'users', 'roles', 'reports', 'super-admin'
    ]
  },
  {
    id: 'pos_sales_first',
    name: '⚡ Retail & POS First',
    description: 'Optimized for high-volume retail stores. POS, Sales, Quotations, and Customers appear first.',
    order: [
      'pos', 'sales', 'quotations', 'customers', 'products', 'categories',
      'inventory', 'imei-tracking', 'repairs', 'trade-ins', 'purchases',
      'expenses', 'cash-bank-operations', 'dashboard', 'reports', 'users', 'roles'
    ]
  },
  {
    id: 'finance_first',
    name: '💼 Accounting & Finance First',
    description: 'Prioritizes Cash & Bank, Invoices, Expenses, Vouchers, Cheques, and P&L Reports.',
    order: [
      'dashboard', 'cash-bank-operations', 'bank-accounts', 'bank-reconciliation',
      'expenses', 'vouchers', 'cheques', 'chequebooks', 'fixed-assets',
      'sales', 'purchases', 'customers', 'reports', 'users', 'roles'
    ]
  },
  {
    id: 'inventory_procurement',
    name: '📦 Inventory & Supply Chain First',
    description: 'Focuses on Stock Levels, IMEI Tracking, Purchases, RMA, and Products.',
    order: [
      'dashboard', 'inventory', 'imei-tracking', 'products', 'categories',
      'purchases', 'rma', 'warranty-periods', 'sales', 'pos',
      'suppliers', 'expenses', 'reports', 'users'
    ]
  }
];
